<template>
     <div class="w-full h-full flex flex-col items-center justify-center text-center p-4">

                <typography variant="h4">Set up CLI!</typography>
                <typography variant="p" class="text-gray-600 mt-2 max-w-xl">Copy this token and paste it into the CLI</typography>
                <input type="text" :value="token" />

                <!-- <router-link
                        :to="{ name: 'Project' }"
                        title="Back To Project"
                        class="text-secondary dark:text-secondary-300 underline focus:outline-none focus:shadow-outline mt-4 hover:opacity-75 transition duration-150"
                    >
                        Back To Project
                </router-link> -->

            </div>
</template>

<script>
export default {
    name: "CLIPage",
    metaInfo: {
      title: 'Set up CLI',
    },
    data() {
        return {
          token: 'loading'
        }
    },
    async mounted () {
        this.token = await this.$auth.currentUser.getIdToken();
    }
}
</script>